module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_fails.js
// module id = 18
// module chunks = 0